export enum ValidationResponseStatus {
	PENDING = 'pending',
	FINISHED = 'finished'
}
